import React from 'react'

export default function Loading() {

  return <div className='tab-content'>Loading...</div>

}